import React, { useEffect, useRef, useState } from "react";
import {
  ADDFEESICON,
  DOCTOR_DETAIL_IAMGE,
  PROFILE_IMG,
  EDIT_FEESICON,
  EDIT_ICON,
  PLUSICON,
} from "../../utils/aap-image-constant";
import TableLayout from "../../components/layouts/table-layout";
import TableHeading from "../../components/common/TableHeading";
import Modal from "../../components/common/Model";
import { useNavigate } from "react-router-dom";
import { ROUTES } from "../../hooks/routes/routes-constant";
import { useTranslation } from "react-i18next";
import {
  addDoctorFeesByClinic,
  doctorBlockByClinic,
  doctorListforAvailability,
  translateLanguage,
} from "../../hooks/services/api-services";
import { useSelector } from "react-redux";
import {
  decryptAEStoJSON,
  EllipsisWithTooltip,
  toastEmitter,
} from "../../utils/utilities";
import { API_RESPONSE, DEFAULT_PAGE_LENGTH } from "../../utils/app-constants";
import Input from "../../components/common/input";
import Button from "../../components/common/button";
import { getCurrencySymbol, handleFormInput } from "../../utils/form-utils";
import TextArea from "../../components/common/text-area";
import AccessPermissionpage from "../../components/common/accessPermissionpage";
import { API_URL } from "../../utils/url-constants";

const Doctor = () => {
  const { t, i18n } = useTranslation();
  const navigate = useNavigate();
  const isFirstRender = useRef(true);
  const ViewModel = useRef(null);
  const AddFeesModel = useRef(null);
  const [searchTerm, setSearchTerm] = useState("");
  const [pending, setPending] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [page, setPage] = useState(0);
  const [pageSize, setPageSize] = useState(DEFAULT_PAGE_LENGTH);
  const [viewData, setViewData] = useState({});
  const [sortColumn, setSortColumn] = useState("");
  const [sortDirection, setSortDirection] = useState("");
  const [totalRows, setTotalRows] = useState(0);
  const [rowData, setRowData] = useState([]);
  const [modalType, setModalType] = useState("");
  const { value } = useSelector((state) => state?.loggedUser);
  const userData = decryptAEStoJSON(value);
  const adminShare = Number(userData?.adminPercentage || 0);
  const remainingShare = 100 - adminShare;

  const payload = {
    pageIndex: searchTerm === "" ? page || 0 : 0,
    pageSize: pageSize || DEFAULT_PAGE_LENGTH,
    status: null,
    country: userData?.country,
    clinicId: userData?.id,
    searchText: searchTerm,
    direction: sortDirection || "desc",
    filterByFieldName: sortColumn || "id",
    bothDoctors: false,
    type: "",
    languageType: i18n.language,
  };
  const [addFees, setAddFees] = useState({
    doctorId: "",
    clinicId: userData?.id,
    fees: "",
    doctorPercent: "",
    clinicPercent: "",
  });

  const [updateFees, setUpdateFess] = useState("");
  const handleDoctorBlock = async (clinicId, doctorId, status) => {
    try {
      const response = await doctorBlockByClinic(clinicId, doctorId, status);
      if (response.status !== 200) {
        toastEmitter("error", response?.data?.message);
      } else {
        toastEmitter("success", response?.data?.message);
        fetchDoctorData();
      }
    } catch (err) {
      toastEmitter("error", API_RESPONSE?.MESSAGE_503);
    }
  };

  const fetchDoctorData = async () => {
    setPending(true);
    try {
      const response = await doctorListforAvailability(payload);
      if (response?.data?.status !== 200) {
        if (isFirstRender?.current) {
        }
        setRowData([]);
      } else {
        setRowData(response?.data?.data?.doctorResponseList);
        setTotalRows(response?.data?.data?.totalElement);
      }
    } catch (err) {
      if (isFirstRender.current) {
        toastEmitter("error", API_RESPONSE?.MESSAGE_503);
      }
    } finally {
      setPending(false);
      isFirstRender.current = false;
    }
  };
  useEffect(() => {
    fetchDoctorData();
  }, [page, pageSize, searchTerm, sortDirection, sortColumn, i18n.language]);

  const currencySign = getCurrencySymbol(userData?.country);

  const tableColumns = [
    {
      code: "S.No",
      name: t("S.No"),
      width: "100px",
      omit: false,
      selector: (row, index) => `${page * pageSize + index + 1}`,
    },
    {
      code: "first_name",
      name: t("Doctor Name"),
      selector: (row) => row?.d_name,
      sortable: true,
      width: "200px",
      cell: (row) => (
        <div className="d-flex gap-2 align-items-center fs-12 fw-600">
          <div className="rounded-circle overflow-hidden rounded-circle">
            <img
              src={
                row?.image ? `${API_URL?.ServerURL}${row?.image}` : PROFILE_IMG
              }
              alt=""
              style={{
                objectFit: "cover",
                objectPosition: "center",
                width: "32px",
                height: "32px",
              }}
            />
          </div>
          {`${row?.firstName}  ${row?.lastName}`}
        </div>
      ),
    },

    {
      code: "email",
      name: t("E-mail"),
      sortable: true,
      width: "200px",
      selector: (row) => (
        <EllipsisWithTooltip text={`${row?.email || "N/A"}`} maxWidth="250px" />
      ),
    },
    {
      code: "address",
      width: "220px",
      name: t("Address"),
      selector: (row) => (
        <EllipsisWithTooltip
          text={`${userData?.address || row?.address || "N/A"}`}
          maxWidth="250px"
        />
      ),
    },
    {
      code: "experience",
      width: "150px",
      name: t("Experience"),
      selector: (row) => (
        <EllipsisWithTooltip
          text={`${row?.experience || "N/A"}`}
          maxWidth="250px"
        />
      ),
    },
    {
      code: "mobileNo",
      name: t("Mobile Number"),
      width: "200px",
      cell: (row) => {
        return <>{`${row?.code} ${row?.mobileNo}`}</>;
      },
    },
    {
      code: "specialization",
      name: t("Specialization"),
      width: "180px",
      selector: (row) => row?.specialization,
    },
    {
      code: "status",
      name: t("Status"),
      selector: (row) => row?.status,
      cell: (row) => (
        <div
          className={`d-flex align-items-center gap-1 px-2 py-1 rounded-4 cursor-pointer
    ${row.status === 1
              ? "bg-green-normal color-green-bold"
              : "bg-gray-normal color-gray-bold"
            }
    ${permissionAccess?.moduleAction === 0 ? "disabled-style" : ""}
  `}
          onClick={(e) => {
            if (permissionAccess?.moduleAction !== 0) {
              handleDoctorBlock(
                userData?.id,
                row?.id,
                row?.status === 1 ? 0 : 1,
              );
            }
          }}
        >
          <div
            className={`rounded-circle ${row?.status === 1 ? "bg-green-bold" : "bg-gray-bold"
              }`}
            style={{ width: "10px", height: "10px" }}
          ></div>
          <p className="m-0 fs-14 fw-normal">
            {row?.status === 1 ? t("Active") : t("Inactive")}
          </p>
        </div>
      ),
    },

    {
      code: "clinicFees",
      name: t("Fees"),
      width: "200px",
      sortable: false,
      cell: (row) => {
        const isDisabled = permissionAccess?.updateAction !== 1;

        return (
          <div
            onClick={() => {
              if (!isDisabled) openFeesModal(row);
            }}
            className={`cursor-pointer bg-green-normal rounded p-2 d-flex align-items-center ${isDisabled ? "disabled-style" : ""
              }`}
            style={isDisabled ? { pointerEvents: "none", opacity: 0.6 } : {}}
          >
            {row?.clinicFees === null ? (
              <span className="fw-600 color-green-bold">
                {t("Fees")}
                <img
                  src={ADDFEESICON}
                  alt="add fees"
                  className="editicon ms-2"
                />
              </span>
            ) : (
              <>
                <span className="fw-600 color-green-bold">
                  {currencySign}
                  {row?.clinicFees}
                </span>
                <img src={EDIT_FEESICON} alt="edit" className="editicon ms-2" />
              </>
            )}
          </div>
        );
      },
    },
    {
      code: "questions",
      name: t("Question"),
      width: "130px",
      sortable: false,
      cell: (row) => {
        const isQuestionAdded = Number(row?.isQuestionAdded) === 1;
        const iconSrc = isQuestionAdded ? EDIT_ICON : PLUSICON;
        const altText = isQuestionAdded ? "Edit" : "Add";
        const isDisabled = permissionAccess?.updateAction !== 1;

        return (
          <div>
            <button
              className={`border-0 btn-blue rounded text-white p-2 ${isDisabled ? "disabled-style" : ""
                }`}
              onClick={() => {
                if (!isDisabled) openquestionModal(row);
              }}
              disabled={isDisabled}
              style={isDisabled ? { pointerEvents: "none", opacity: 0.6 } : {}}
            >
              {altText}
              <span>
                <img src={iconSrc} alt={altText} className=" ms-2" />
              </span>
            </button>
          </div>
        );
      },
    },
    {
      code: "Detail",
      name: t("Detail"),
      width: "130px",
      sortable: false,
      cell: (row) => {
        const isDisabled = permissionAccess?.viewAction !== 1;
        return (
          <div>
            <button
              className={`border-0 bg-white ${isDisabled ? "disabled-style" : ""
                }`}
              onClick={() => {
                if (!isDisabled) openViewModal(row);
              }}
              disabled={isDisabled}
              style={isDisabled ? { pointerEvents: "none", opacity: 0.6 } : {}}
            >
              <img
                src={DOCTOR_DETAIL_IAMGE}
                alt="View"
                className="editicon ms-2"
              />
            </button>
          </div>
        );
      },
    },
  ];
  useEffect(() => {
    if (modalType === "fees") {
      AddFeesModel?.current?.click();
    }
  }, [modalType]);
  const openFeesModal = (doctor) => {
    setModalType(null); // Reset first to trigger useEffect
    setTimeout(() => {
      setModalType("fees");
      setAddFees({
        fees: doctor?.clinicFees == null ? "" : doctor?.clinicFees,
        doctorId: doctor?.id,
        clinicId: userData?.id,
        doctorPercent: doctor?.clinicDoctorPercentage || "",
        clinicPercent: doctor?.clinicPercentage || "",
      });
      setUpdateFess(doctor?.clinicFees);
    }, 0); // Timeout ensures React detects the change
  };

  useEffect(() => {
    if (modalType === "view" && viewData) {
      ViewModel?.current?.click();
    }
  }, [viewData, modalType]);
  const openViewModal = (data) => {
    setModalType("view");
    setViewData(data);
  };

  const openquestionModal = (row) => {
    const doctorId = row?.id;
    const isQuestionAdded = Number(row?.isQuestionAdded) === 1;

    if (isQuestionAdded) {
      navigate(`/doctor/addquestion/${doctorId}/edit`);
    } else {
      navigate(`/doctor/addquestion/${doctorId}/add`);
    }
  };
  const addClinicDoctorFees = (
    e,
    docId,
    clinicId,
    fees,
    doctorShare,
    clinicShare,
  ) => {
    e.preventDefault();
    if (!fees) {
      toastEmitter("error", t("Please enter fees amount"));
      return;
    }
    if (Number(doctorShare) + Number(clinicShare) !== remainingShare) {
      toastEmitter(
        "error",
        `Doctor + Clinic share must equal ${remainingShare}%`,
      );
      return;
    }

    if (!doctorShare) {
      toastEmitter("error", "Doctor Percentage is Madatory");
      return;
    }
    if (!clinicShare) {
      toastEmitter("error", "Clinic Percentage is Madatory");
      return;
    }
    setIsLoading(true);
    addDoctorFeesByClinic(docId, clinicId, fees, doctorShare, clinicShare)
      .then((response) => {
        if (response.data?.status !== 200) {
          toastEmitter("error", response?.data?.message);
          setIsLoading(false);
        } else {
          const isUpdate = updateFees !== null && updateFees !== "";
          toastEmitter(
            "success",
            isUpdate
              ? t("Fees updated successfully")
              : t("Fees added successfully"),
          );
          setAddFees({
            doctorId: "",
            clinicId: userData?.id,
            fees: "",
            doctorPercent: "",
            clinicPercent: "",
          });

          AddFeesModel?.current?.click();
          fetchDoctorData();
          setIsLoading(false);
        }
      })
      .catch(() => {
        toastEmitter(t("error"), API_RESPONSE?.MESSAGE_503);
        setIsLoading(false);
      });
  };
  const doctorAddPageNavigate = () => {
    navigate(`${ROUTES.DOCTOR}/add`);
  };
  // permission code for this module start
  const [permissionAccess, setPermissionAccess] = useState();
  const rawPermission = useSelector((state) => state?.permission?.value);
  const permissions = decryptAEStoJSON(rawPermission);

  useEffect(() => {
    const RoleAccessFilterData =
      permissions &&
      permissions?.filter((v) => v?.moduleName === "Doctor Management");
    setPermissionAccess(RoleAccessFilterData?.[0]);
  }, []);

  return (
    <>
      {permissionAccess?.addAction === 0 &&
        permissionAccess?.updateAction === 0 &&
        permissionAccess?.viewAction === 0 ? (
        <>
          <AccessPermissionpage />
        </>
      ) : (
        <>
          <div className="main_datatable mt-lg-3 mt-1">
            <TableHeading
              title={t("Doctor Management")}
              searchValue={searchTerm}
              setSearchValue={setSearchTerm}
              data="Doctor"
              addButtonClick={doctorAddPageNavigate}
              showbutton={permissionAccess?.addAction === 1}
            />
            <div className="table-wrapper">
              <TableLayout
                _tblColumns={tableColumns}
                _rowData={rowData}
                pending={pending}
                pagination={true}
                selectableRows={false}
                setPending={setPending}
                _totalRows={totalRows}
                pageSize={pageSize}
                setPageSize={setPageSize}
                setPage={setPage}
                setSortColumn={setSortColumn}
                setSortDirection={setSortDirection}
              />
            </div>
            {modalType === "fees" && (
              <Modal
                modalId="addfeesdoctor"
                modalClick={AddFeesModel}
                AddFeesModel={AddFeesModel}
                heading={
                  updateFees === null
                    ? t("Add Clinic Doctor Fees")
                    : t("Edit Clinic Doctor Fees")
                }
                className=""
              >
                <form
                  onSubmit={(e) =>
                    addClinicDoctorFees(
                      e,
                      addFees?.doctorId,
                      addFees?.clinicId,
                      addFees?.fees,
                      addFees?.doctorPercent,
                      addFees?.clinicPercent,
                    )
                  }
                >
                  <div className="mb-4">
                    <Input
                      type="number"
                      value={addFees?.fees}
                      name="fees"
                      placeHolder={`Enter Fees (${currencySign})`}
                      handleChange={(e) =>
                        setAddFees(handleFormInput(e, addFees))
                      }
                      labelName="Fees"
                      onKeyDown={(e) => {
                        if (
                          [
                            "e",
                            "E",
                            "+",
                            "-",
                            ".",
                            "ArrowUp",
                            "ArrowDown",
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      lableClassName="d-flex align-items-start"
                    />
                  </div>

                  <div className="mb-4">
                    <Input
                      type="number"
                      value={adminShare}
                      name="adminPercent"
                      labelName="Admin Share Percentage %"
                      disabled
                      lableClassName="d-flex align-items-start"
                    />
                  </div>

                  {/* <div className="mb-4">
                    <Input
                      type="number"
                      value={addFees?.clinicPercent}
                      name="clinicPercent"
                      placeHolder={`Enter Clinic Share Percentage %`}
                      onChange={(e) => {
                        const input = e.target.value;
                        if (/^\d{0,3}$/.test(input)) {
                          const adminValue = parseInt(input || "0");

                          if (adminValue > 100) {
                            toastEmitter(
                              "error",
                              "Admin share cannot be more than 100%"
                            );
                            return;
                          }

                          const doctorValue = 100 - adminValue;

                          setAddFees((prev) => ({
                            ...prev,
                            clinicPercent: input,
                            doctorPercent: doctorValue.toString(),
                          }));
                        }
                      }}
                      labelName="Clinic Share Percentage %"
                      onKeyDown={(e) => {
                        if (
                          [
                            "e",
                            "E",
                            "+",
                            "-",
                            ".",
                            "ArrowUp",
                            "ArrowDown",
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      lableClassName="d-flex align-items-start"
                    />
                  </div> */}
                  <Input
                    type="number"
                    value={addFees?.clinicPercent}
                    name="clinicPercent"
                    placeHolder={`Enter Clinic Share Percentage (Max ${remainingShare}%)`}
                    labelName="Clinic Share Percentage %"
                    lableClassName="d-flex align-items-start"

                    onChange={(e) => {
                      const value = parseFloat(e.target.value);
                      
                      if (value < 0) return;

                      if (value > remainingShare) {
                        toastEmitter(
                          "error",
                          `Clinic share cannot exceed ${remainingShare}% (after admin ${adminShare}%)`,
                        );
                        return;
                      }

                      const doctorValue = remainingShare - value;

                      setAddFees((prev) => ({
                        ...prev,
                        clinicPercent: value,
                        doctorPercent: doctorValue,
                      }));
                    }}
                  />

                  <div className="mb-4">
                    <Input
                      type="number"
                      value={addFees?.doctorPercent}
                      name="doctorPercent"
                      labelName="Doctor Share Percentage %"
                      readOnly
                      lableClassName="d-flex align-items-start"
                    />
                  </div>

                  {/* <div className="mb-4">
                    <Input
                      type="number"
                      value={addFees?.doctorPercent}
                      name="doctorPercent"
                      placeholder="Auto calculated"
                      handleChange={(e) =>
                        setAddFees(handleFormInput(e, addFees))
                      }
                      labelName="Doctor Share Percentage %"
                      onKeyDown={(e) => {
                        if (
                          [
                            "e",
                            "E",
                            "+",
                            "-",
                            ".",
                            "ArrowUp",
                            "ArrowDown",
                          ].includes(e.key)
                        ) {
                          e.preventDefault();
                        }
                      }}
                      onWheel={(e) => e.target.blur()}
                      lableClassName="d-flex align-items-start"
                      showAsterisk={true}
                      readOnly
                    />
                  </div> */}
                  <Button
                    type="submit"
                    className="px-5 py-2 rounded border-0 submitbtn me-2 text-white"
                    label={updateFees === null ? "Add Fees" : t("Edit Fees")}
                    isLoading={isLoading}
                  />
                </form>
              </Modal>
            )}

            {modalType === "view" && (
              <Modal
                closebtnclass="closebtnclass"
                modalId="viewdoctordetails"
                modalClick={ViewModel}
                className="modal-lg"
                modalContentClass="add_doctor card px-3 py-0 border border-radius_input"
              >
                <div className="">
                  <div className="row text-start">
                    <h3 className="text-start fs-16 fw-600 mt-3">
                      {t("Basic Informations")}
                    </h3>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={`${viewData?.firstName || ""} ${viewData?.lastName || ""
                          }`}
                        name="firstName"
                        labelName="Doctor Name"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={viewData?.email}
                        name="email"
                        labelName="Email"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={`${viewData?.code || ""} ${viewData?.mobileNo || ""
                          }`}
                        name="mobileNo"
                        labelName="Mobile Number"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={viewData?.gender}
                        name="gender"
                        labelName={t("Gender")}
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={viewData?.specialization || ""}
                        name="specialty"
                        labelName="Specialization"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={viewData?.country || ""}
                        name="country"
                        labelName="Country"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    <div className="col-md-6 mb-2">
                      <Input
                        type="text"
                        value={viewData?.profile || ""}
                        name="profile"
                        labelName="Profile"
                        disabled={true}
                        showAsterisk={false}
                      />
                    </div>
                    {viewData?.address && (
                      <div className="col-md-6 mb-2">
                        <Input
                          type="text"
                          value={viewData?.address || ""}
                          name="address"
                          labelName="Address"
                          disabled={true}
                          showAsterisk={false}
                        />
                      </div>
                    )}
                    {viewData?.experience && (
                      <div className="col-md-6 mb-2">
                        <Input
                          type="text"
                          value={viewData?.experience || ""}
                          name="experience"
                          labelName={t("Experience")}
                          disabled={true}
                          showAsterisk={false}
                        />
                      </div>
                    )}
                    {viewData?.description && (
                      <div className="col-md-12 mb-2">
                        <TextArea
                          type="text"
                          value={viewData?.description || ""}
                          name="description"
                          labelName={t("Brief Description")}
                          disabled={true}
                          showAsterisk={false}
                        />
                      </div>
                    )}
                  </div>
                  <div className="card p-3 border border-radius_input my-4 text-start">
                    <h3 className="fw-600 fs-16">{t("Fees Detail")}</h3>
                    <Input
                      type="text"
                      value={
                        viewData?.clinicFees
                          ? `${currencySign}${viewData?.clinicFees}`
                          : ""
                      }
                      name="clinicFees"
                      labelName="Fees"
                      disabled={true}
                      showAsterisk={false}
                    />
                  </div>
                </div>
              </Modal>
            )}
          </div>
        </>
      )}
    </>
  );
};

export default Doctor;
